export default __webpack_public_path__ + "static/media/chart.03400f1a.svg";